import {
    MAX_BOOSTER_JOKER,
    MAX_BOOSTER_TNT,
    MAX_COINS,
    MAX_LIVES,
} from '../../Constants/Player';
import { IGameState } from '../Game/IGameState';
import { ProductID, ProductValueMap } from '../Player/Product';

export type PurchaseOverflow = {
    coins: number;
    lives: number;
    boosterTNT: number;
    boosterJokers: number;
};

/**
 * Calculate if purchasing the specified product will exceed any maximum values for player properties.
 * If no overflow (differences) are calculated then null is returned.
 * @param state
 * @param productID
 */
export function getPurchaseOverflow(
    state: IGameState,
    productID: ProductID
): PurchaseOverflow {
    const product = ProductValueMap[productID];

    return {
        coins: product.coins
            ? Math.min(product.coins || 0, MAX_COINS - state.playerState.coins)
            : undefined,
        lives: product.lives
            ? Math.min(product.lives, MAX_LIVES - state.playerState.lives)
            : undefined,
        boosterTNT: product.boosterTNT
            ? Math.min(
                  product.boosterTNT,
                  MAX_BOOSTER_TNT - state.playerState.inventory.boosterTNT
              )
            : undefined,
        boosterJokers: product.boosterJokers
            ? Math.min(
                  product.boosterJokers,
                  MAX_BOOSTER_JOKER - state.playerState.inventory.boosterJoker
              )
            : undefined,
    };
}

/**
 * Check if a product cannot be fully redeemed due to property limits.
 * @param state
 * @param productID
 */
export function hasPurchaseOverflow(
    state: IGameState,
    productID: ProductID
): boolean {
    const product = ProductValueMap[productID];
    const overflow = getPurchaseOverflow(state, productID);

    return (
        overflow.coins !== product.coins ||
        overflow.lives !== product.lives ||
        overflow.boosterJokers !== product.boosterJokers ||
        overflow.boosterTNT !== product.boosterTNT
    );
}
